module.exports = __webpack_public_path__ + "img/openDoor.ed525d0b.png";